const isDialogVisibleSelector = (state) => {
  return (name) => {
    return state.getIn(['dialogs', name, 'visible']);
  };
};

const getDialogContextValue = (state) => (dialog, name) => name ? state.getIn(['dialogs', dialog, 'context', name]) : state.getIn(['dialogs', dialog, 'context']);

export {
  isDialogVisibleSelector,
  getDialogContextValue,
};



// WEBPACK FOOTER //
// ./src/redux/selectors.js